import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { SLIDER_CONFIG } from '../../../../shared/constants/constants';
import { FaqModel } from '../../../../shared/models/faq.model';
import { FaqService } from '../../../../shared/services/faq.service';
import { SharedModule } from '../../../../shared/shared.module';
import { TopicCardComponent } from '../topic-card/topic-card.component';

@Component({
  selector: 'app-topic-carousel',
  standalone: true,
  imports: [
    TopicCardComponent,
    SlickCarouselModule,
    SharedModule,
    ConfirmationModalComponent,
  ],
  templateUrl: './topic-carousel.component.html',
  styleUrl: './topic-carousel.component.scss',
})
export class TopicCarouselComponent {
  @Input() faqList: FaqModel[] = [];
  @Input() selectedTopic: FaqModel | null = null;
  @Output() onFaqClick: EventEmitter<FaqModel> = new EventEmitter();
  @Output() onFaqUpdate: EventEmitter<void> = new EventEmitter();
  @Output() onEditTopic: EventEmitter<FaqModel> = new EventEmitter();
  slideConfig = SLIDER_CONFIG;
  menuOpenIndex = -1;
  deleteLoading = false;
  showDelteConfirmation = false;
  deleteTopicId: string = '';

  constructor(private faqService: FaqService, private toastr: ToastrService) {}

  closeAllMenu(index: number) {
    if (index === this.menuOpenIndex) {
      this.menuOpenIndex = -1;
    }
  }
  handleMenuOpen(index: number) {
    this.menuOpenIndex = index;
  }

  handleFaqClick(faq: FaqModel) {
    this.onFaqClick.emit(faq);
  }
  handleDeleteTopic(id: string) {
    this.deleteTopicId = id;
    this.toggleDeleteModal(true);
  }
  handleEditTopic(faq: FaqModel) {
    this.onEditTopic.emit(faq);
  }

  toggleDeleteModal(state: boolean) {
    this.showDelteConfirmation = state;
    if (!state) {
      this.deleteTopicId = '';
    }
  }

  deleteTopic() {
    this.deleteLoading = true;
    this.faqService.deleteTopic(this.deleteTopicId ?? '').subscribe({
      next: (res) => {
        this.deleteLoading = false;
        this.toastr.success('Blog deleted successfully.');
        this.toggleDeleteModal(false);
        this.onFaqUpdate.emit();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
      },
    });
  }
}
